import { getJson } from "../../auth/utils/getJson.js";

/** GET /api/operators/export-unit-exclusions */
export function fetchExportUnitExclusions(signal) {
  return getJson("/api/operators/export-unit-exclusions", { signal })
    .then((json) => (Array.isArray(json) ? json : []));
}
